import React, { useState } from 'react';
import { Card, Row, Col, InputNumber, Button, Typography, Switch, Tooltip } from 'antd';
import { UpOutlined, DownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Text } = Typography;

// Sticky components for the sticky container
const StickyContainer = styled.div`
  position: fixed;
  bottom: ${props => props.isCollapsed ? '20px' : '20px'};
  right: 20px;
  z-index: 1000;
  width: ${props => props.isCollapsed ? '300px' : '300px'};
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
`;

const CollapseButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
`;

const StickyCalculatorInputs = ({
  inputs,
  onInputChange,
  selectedTaxYear,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Format value as currency
  const formatCurrency = (value) => {
    if (value === undefined || value === null) return '';
    return `£ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Parse currency string back to number
  const parseCurrency = (value) => {
    return value.replace(/£\s?|(,*)/g, '');
  };

  // Handle input changes consistently with the main form
  const handleInputChange = (name, value) => {
    // Ensure we're passing a number for numeric fields
    if (name === 'baseSalary' || name === 'employeePensionContribution') {
      value = value === '' ? '' : Number(value);
    }
    onInputChange(name, value);
  };

  return (
    <StickyContainer isCollapsed={isCollapsed}>
      <Card 
        size="small"
        title={isCollapsed ? "Quick Input Controls" : "Quick Input Controls"}
        bodyStyle={{ padding: isCollapsed ? '10px' : '16px' }}
      >
        <CollapseButton 
          type="text" 
          icon={isCollapsed ? <UpOutlined /> : <DownOutlined />}
          onClick={toggleCollapse}
          size="small"
        />

        {!isCollapsed && (
          <>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Text strong>Base Salary:</Text>
                <InputNumber
                  style={{ width: '100%' }}
                  value={inputs.baseSalary}
                  onChange={(value) => handleInputChange('baseSalary', value)}
                  formatter={formatCurrency}
                  parser={parseCurrency}
                  step={1000}
                  min={0}
                />
              </Col>
              
              <Col span={24}>
                <Text strong>
                  Pension Contribution:
                  <Tooltip title="Percentage of salary contributed to pension">
                    <InfoCircleOutlined style={{ marginLeft: 8 }} />
                  </Tooltip>
                </Text>
                <InputNumber
                  style={{ width: '100%' }}
                  value={inputs.employeePensionContribution}
                  onChange={(value) => handleInputChange('employeePensionContribution', value)}
                  formatter={value => `${value}%`}
                  parser={value => value.replace('%', '')}
                  min={0}
                  max={100}
                  step={0.5}
                />
              </Col>
            </Row>
            
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Tax Year: {selectedTaxYear}
              </Text>
            </div>
          </>
        )}
      </Card>
    </StickyContainer>
  );
};

export default StickyCalculatorInputs;